export default __webpack_public_path__ + "static/menu-dont-8f639f8eb823e90145eb029977b54d858b64992c0b6da5d00cf9be4da167e03f.png";